/* Blog content lives here, not in the page components, so posts can be added
   without touching layout and so the prerender step has one place to read from.

   Every post needs: slug, category (must exist in CATEGORIES), title, excerpt,
   date (ISO), art (a key handled by components/blog/BlogArt.js) and body.
   Body blocks are { h2, p: [...] } or { list: [...] } so the article page and
   the crawler both get real headings and paragraphs. */

export const CATEGORIES = [
  { id: "all", label: "Semua" },
  { id: "panduan", label: "Panduan" },
  { id: "khidmat", label: "Khidmat pelanggan" },
  { id: "adab", label: "Bahasa & adab" },
  { id: "berita", label: "Berita Bicarra" },
];

export const POSTS = [
  {
    slug: "chatbot-pertama-anda",
    category: "panduan",
    eyebrow: "Panduan pilihan",
    featured: true,
    date: "2026-09-21",
    readMinutes: 6,
    art: "guide",
    title: "Chatbot pertama anda, tanpa pening kepala.",
    excerpt:
      "Ketahui apa yang perlu disediakan, cara mencuba jawapan, dan bila sesuai untuk mula.",
    body: [
      {
        p: [
          "Kebanyakan orang menangguhkan chatbot kerana ia terasa seperti projek teknologi. Sebenarnya ia lebih dekat dengan kerja menyusun maklumat. Kalau anda sudah menjawab soalan pelanggan setiap hari, anda sudah ada bahannya.",
        ],
      },
      {
        h2: "Mula dengan soalan yang anda jawab paling kerap",
        p: [
          "Buka WhatsApp atau inbox anda dan tatal ke bawah. Senaraikan sepuluh soalan yang paling kerap berulang. Waktu operasi, harga, kos penghantaran, cara bayar, lokasi, dasar pemulangan.",
          "Sepuluh soalan itu biasanya mewakili sebahagian besar mesej masuk. Kalau chatbot anda hanya menjawab sepuluh itu dengan betul, anda sudah menjimatkan banyak masa.",
        ],
      },
      {
        h2: "Kumpulkan bahan yang sudah ada",
        p: [
          "Anda tidak perlu menulis dokumen baharu. Bahan yang berguna selalunya sudah wujud:",
        ],
        list: [
          "Laman web atau halaman Facebook perniagaan anda",
          "Senarai harga atau katalog produk",
          "Dasar penghantaran dan pemulangan",
          "Jawapan yang anda sendiri sudah taip berulang kali dalam chat",
        ],
      },
      {
        h2: "Cuba dahulu sebagai pelanggan",
        p: [
          "Selepas chatbot dilatih, jangan terus pasang di laman web. Duduk sepuluh minit dan tanya seperti pelanggan sebenar, termasuk soalan yang ditaip separuh jalan atau bercampur bahasa.",
          "Perhatikan dua perkara. Pertama, adakah jawapannya betul. Kedua, adakah nadanya seperti perniagaan anda. Kalau jawapan betul tetapi bunyinya kaku, pelanggan tetap akan rasa janggal.",
        ],
      },
      {
        h2: "Biarkan ia berkata tidak tahu",
        p: [
          "Chatbot yang baik tahu bila untuk berhenti. Lebih selamat ia berkata tidak pasti dan menawarkan untuk menghubungkan pelanggan dengan manusia, daripada mereka-reka jawapan tentang harga atau stok.",
          "Ini bukan kelemahan. Pelanggan lebih mempercayai perniagaan yang jujur tentang apa yang ia tidak tahu.",
        ],
      },
      {
        h2: "Bila sesuai untuk mula",
        p: [
          "Kalau anda menjawab soalan yang sama lebih daripada beberapa kali sehari, sekarang sudah sesuai. Kalau perniagaan anda masih kerap menukar harga atau produk, sediakan dahulu satu sumber maklumat yang kemas, kerana chatbot hanya sebaik bahan yang anda beri.",
        ],
      },
    ],
  },
  {
    "slug": "kajian-tindakan-dalam-pendidikan",
    "category": "panduan",
    "eyebrow": "Panduan pendidikan",
    "date": "2026-11-02",
    "readMinutes": 4,
    "art": "guide",
    "title": "Kajian tindakan dalam pendidikan: panduan langkah demi langkah, dan di mana AI boleh membantu.",
    "excerpt": "Kajian tindakan membantu guru menambah baik amalan sendiri secara bersistem. Panduan ringkas tentang kitaran kajian tindakan, cara memilih fokus yang kecil, dan bahagian yang boleh dibantu AI tanpa menjejaskan data dan kejujuran kajian.",
    "body": [
      {
        "p": [
          "Ramai guru pertama kali bertemu kajian tindakan semasa latihan perguruan, kemudian diminta melaksanakannya semula di sekolah untuk kolokium, panitia atau kenaikan pangkat. Istilahnya biasa didengar, tetapi apabila tiba masa menulis, soalan yang sama sering timbul: dari mana hendak bermula, berapa besar masalah yang patut dipilih, dan bagaimana menulisnya dengan kemas.",
          "Artikel ini menerangkan kajian tindakan dalam pendidikan secara praktikal. Ia menghuraikan kitarannya, cara memilih fokus yang boleh diurus, dan bahagian kerja yang boleh dibantu oleh AI, serta bahagian yang mesti kekal di tangan anda."
        ]
      },
      {
        "h2": "Apa itu kajian tindakan",
        "p": [
          "Kajian tindakan ialah kajian yang dijalankan oleh pengamal ke atas amalannya sendiri, dengan tujuan untuk menambah baik amalan itu. Dalam konteks sekolah, pengamal itu ialah guru, dan amalan yang dikaji ialah pengajaran dan pembelajaran di bilik darjahnya.",
          "Ia berbeza daripada kajian akademik yang besar. Tujuannya bukan untuk membuat generalisasi kepada semua sekolah, tetapi untuk memahami satu masalah sebenar dalam kelas anda, mencuba satu tindakan, dan melihat sama ada tindakan itu membawa perubahan. Kerana itu skala yang kecil bukan kelemahan. Ia memang sifat kajian tindakan."
        ]
      },
      {
        "h2": "Kitaran kajian tindakan",
        "p": [
          "Terdapat beberapa model kajian tindakan, tetapi yang paling kerap dirujuk dalam latihan guru ialah model Kemmis dan McTaggart. Model ini menggambarkan kajian sebagai kitaran empat langkah yang boleh diulang:"
        ],
        "list": [
          "Merancang: mengenal pasti masalah, memahami puncanya, dan merancang satu tindakan atau intervensi.",
          "Bertindak: melaksanakan intervensi itu dalam pengajaran sebenar mengikut perancangan.",
          "Memerhati: mengumpul data tentang apa yang berlaku, contohnya melalui pemerhatian, hasil kerja murid, ujian ringkas atau temu bual.",
          "Mereflek: menilai data, menimbang apa yang berkesan dan apa yang tidak, kemudian memutuskan sama ada perlu kitaran seterusnya."
        ]
      },
      {
        "p": [
          "Kitaran kedua biasanya lebih tajam daripada yang pertama, kerana ia dibina daripada apa yang dipelajari dalam reflek sebelumnya."
        ]
      },
      {
        "h2": "Pilih fokus yang kecil dan jelas",
        "p": [
          "Kesilapan paling biasa ialah memilih isu yang terlalu luas, seperti \"murid kurang berminat belajar\". Isu begini sukar diukur dan sukar diubah dengan satu tindakan. Fokus yang lebih baik khusus kepada satu kemahiran, satu kumpulan murid, dan satu tempoh yang munasabah.",
          "Sebagai contoh, \"murid Tahun 4 kelas saya keliru membezakan imbuhan me- dan ber- dalam penulisan\" lebih mudah dikaji. Anda boleh melihat buktinya dalam hasil kerja murid, mencuba satu teknik, dan memeriksa semula selepas beberapa minggu. Sebelum memilih, tanya diri anda: adakah masalah ini berlaku dalam kelas saya sendiri, dan adakah saya boleh melakukan sesuatu terhadapnya?"
        ]
      },
      {
        "h2": "Di mana AI boleh membantu",
        "p": [
          "AI tidak boleh menjalankan kajian tindakan untuk anda, kerana ia tidak berada dalam kelas anda dan tidak mengenali murid anda. Tetapi ia boleh meringankan kerja penulisan dan penyusunan yang memakan masa:"
        ],
        "list": [
          "Menajamkan fokus: terangkan masalah anda secara ringkas dan minta AI mencadangkan beberapa versi pernyataan fokus yang lebih khusus. Anda pilih dan ubah yang paling tepat.",
          "Mencadangkan intervensi: minta beberapa idea tindakan untuk masalah tersebut, kemudian nilai sendiri mana yang sesuai dengan murid dan masa yang ada.",
          "Menyediakan instrumen: minta draf senarai semak pemerhatian, soalan temu bual ringkas, atau soalan ujian pra dan pasca, kemudian semak setiap item.",
          "Menyusun penulisan: selepas anda menulis isi, minta AI membetulkan struktur ayat dan susunan bahagian mengikut format yang ditetapkan oleh sekolah, institusi atau penganjur kolokium anda."
        ]
      },
      {
        "p": [
          "Dalam setiap kes, beri AI bahan yang anda sendiri pegang: huraian masalah sebenar, format yang diminta, dan konteks kelas tanpa nama murid. Semakin jelas bahan yang anda beri, semakin kurang kerja membetulkan selepas itu."
        ]
      },
      {
        "h2": "Bahagian yang mesti kekal di tangan guru",
        "p": [
          "Ada bahagian kajian tindakan yang tidak boleh diserahkan kepada AI, kerana di situlah nilai dan kejujuran kajian anda:"
        ],
        "list": [
          "Data: data mesti datang daripada murid dan kelas anda. Jangan sekali-kali meminta AI mencipta markah, petikan temu bual atau dapatan pemerhatian.",
          "Rujukan: AI boleh menyebut tajuk buku atau artikel yang kedengaran meyakinkan tetapi sebenarnya tidak wujud. Semak setiap rujukan pada sumber asal sebelum menulisnya.",
          "Reflek: reflek ialah pertimbangan profesional anda tentang apa yang berlaku. AI boleh membantu mengemaskan ayat, tetapi isinya mesti daripada pengalaman anda.",
          "Maklumat murid: jangan masukkan nama, markah individu atau maklumat peribadi murid ke dalam gesaan. Gunakan label umum seperti \"Murid A\" atau \"kumpulan sederhana\"."
        ]
      },
      {
        "p": [
          "Ikut juga garis panduan sekolah, institusi dan pihak berkuasa pendidikan tentang penggunaan AI dalam penulisan. Jika tidak pasti, bincangkan dengan penyelia, ketua panitia atau penyelaras kajian di sekolah anda."
        ]
      },
      {
        "h2": "Contoh gesaan untuk menajamkan fokus",
        "p": [
          "Gantikan bahagian dalam kurungan dengan maklumat anda:",
          "\"Saya guru [mata pelajaran] [tahun/tingkatan] di Malaysia dan sedang merancang kajian tindakan. Masalah yang saya perhatikan dalam kelas saya ialah [huraian ringkas, termasuk bukti yang anda lihat]. Cadangkan tiga pernyataan fokus kajian yang khusus dan boleh diukur dalam tempoh [bilangan] minggu, dan bagi setiap satu, cadangkan satu jenis data yang boleh saya kumpul. Jangan cadangkan dapatan atau keputusan.\"",
          "Ayat terakhir itu penting. Ia mengingatkan AI bahawa tugasnya membantu merancang, bukan meneka hasil kajian anda."
        ]
      },
      {
        "p": [
          "Prinsip ini tidak terikat kepada satu alat. Ia terpakai sama ada anda menggunakan ChatGPT atau platform seperti Bicarra yang membolehkan anda memilih model daripada beberapa syarikat AI. Panduan lebih lanjut tentang menulis gesaan ada dalam artikel kami tentang ChatGPT untuk guru."
        ]
      },
      {
        "h2": "Ringkasnya",
        "p": [
          "Kajian tindakan dalam pendidikan paling berkesan apabila fokusnya kecil, datanya jujur, dan reflek ditulis daripada pengalaman sebenar. Gunakan kitaran merancang, bertindak, memerhati dan mereflek sebagai rangka. Biarkan AI membantu menajamkan fokus, menyediakan draf instrumen dan mengemaskan penulisan, tetapi pastikan data, rujukan dan pertimbangan profesional kekal milik anda."
        ]
      }
    ]
  },
  {
    "slug": "rph-ai-panduan-guru",
    "category": "panduan",
    "eyebrow": "Panduan pendidikan",
    "date": "2026-10-26",
    "readMinutes": 5,
    "art": "checklist",
    "title": "RPH AI: cara guru menggunakan AI untuk mendraf RPH tanpa hilang kawalan.",
    "excerpt": "Alat RPH AI boleh menjimatkan masa, tetapi draf yang ditulis tanpa arahan jelas selalunya umum dan tersasar daripada DSKP. Panduan ringkas menggunakan AI untuk mendraf RPH sambil kekal sebagai penentu isi.",
    "body": [
      {
        "p": [
          "Menulis Rancangan Pengajaran Harian (RPH) ialah kerja yang berulang setiap minggu. Formatnya hampir sama, tetapi isinya mesti berubah mengikut topik, kelas dan perkembangan murid. Tidak hairanlah ramai guru kini mencari \"RPH AI\" untuk melihat sama ada kecerdasan buatan boleh meringankan beban ini.",
          "Jawapannya, AI boleh membantu mendraf, tetapi ia tidak boleh mengambil alih keputusan pengajaran. Artikel ini menerangkan bahagian RPH yang sesuai dibantu AI, cara memberi arahan yang menghasilkan draf boleh guna, dan perkara yang mesti tetap disemak oleh guru."
        ]
      },
      {
        "h2": "Apa yang boleh, dan tidak boleh, dibuat oleh AI",
        "p": [
          "AI sangat pantas menyusun teks dalam format yang diminta. Ia boleh menukar standard pembelajaran kepada objektif yang ditulis dengan kemas, mencadangkan aktiviti, dan menyediakan draf refleksi. Itu bahagian yang memakan masa tetapi tidak memerlukan pengetahuan tentang murid tertentu.",
          "Apa yang AI tidak tahu ialah kelas anda. Ia tidak tahu murid mana yang belum menguasai topik minggu lepas, berapa lama sebenarnya satu waktu selepas perhimpunan, atau peralatan apa yang ada di bilik darjah. Ia juga tidak tahu format RPH yang ditetapkan oleh sekolah atau panitia anda. Maklumat itu mesti datang daripada anda."
        ]
      },
      {
        "h2": "Bahagian RPH yang sesuai dibantu AI",
        "p": [
          "Gunakan AI untuk bahagian yang berbentuk penulisan dan penyusunan, bukan untuk bahagian yang memerlukan keputusan profesional:"
        ],
        "list": [
          "Objektif pembelajaran: menulis semula standard pembelajaran daripada DSKP kepada objektif yang jelas dan boleh diukur.",
          "Kriteria kejayaan: mencadangkan pernyataan ringkas yang murid boleh faham, berdasarkan objektif yang anda tetapkan.",
          "Aktiviti: memberi beberapa pilihan aktiviti untuk set induksi, perkembangan dan penutup, supaya anda boleh memilih yang sesuai.",
          "Bahan bantu mengajar: menyenaraikan bahan yang mungkin diperlukan untuk aktiviti yang dipilih.",
          "Draf refleksi: menyusun catatan ringkas anda selepas kelas kepada ayat yang kemas."
        ]
      },
      {
        "p": [
          "Bahagian seperti pemilihan standard, penetapan tahap penguasaan murid dan pengubahsuaian untuk murid yang memerlukan sokongan tambahan sebaiknya ditentukan oleh guru sendiri."
        ]
      },
      {
        "h2": "Mulakan dengan DSKP, bukan dengan topik kosong",
        "p": [
          "Kesilapan paling biasa ialah meminta AI \"buat RPH Sains Tahun 4 topik magnet\" tanpa sebarang bahan. AI akan mengisi kekosongan dengan andaian umum, dan hasilnya mungkin tidak sepadan dengan standard kandungan dan standard pembelajaran yang sebenar.",
          "Cara yang lebih selamat ialah menyalin standard pembelajaran yang berkaitan terus daripada DSKP anda dan memasukkannya ke dalam gesaan. Dengan itu AI bekerja daripada dokumen rasmi yang anda pegang, bukan daripada ingatan amnya."
        ]
      },
      {
        "h2": "Contoh gesaan untuk mendraf RPH",
        "p": [
          "Gantikan bahagian dalam kurungan dengan maklumat anda sendiri:",
          "\"Anda membantu seorang guru [mata pelajaran] [tahun/tingkatan] di Malaysia. Berdasarkan standard pembelajaran di bawah, tulis draf RPH untuk satu waktu selama [minit] minit mengikut susunan berikut: objektif pembelajaran, kriteria kejayaan, set induksi, aktiviti perkembangan, penutup, dan bahan bantu mengajar. Murid saya sudah mempelajari [topik sebelumnya] dan ada beberapa murid yang lemah membaca. Gunakan Bahasa Melayu yang mudah dan istilah seperti dalam buku teks. Jangan tambah standard lain. Standard pembelajaran: [tampal di sini].\"",
          "Gesaan ini panjang, tetapi setiap bahagiannya mengurangkan kerja membetulkan selepas itu. Panduan lebih terperinci tentang menulis gesaan ada dalam artikel kami tentang ChatGPT untuk guru."
        ]
      },
      {
        "h2": "Perkara yang mesti anda semak",
        "p": [
          "Anggap setiap draf RPH daripada AI sebagai draf pertama. Sebelum ia digunakan, semak perkara berikut:"
        ],
        "list": [
          "Adakah objektif benar-benar sepadan dengan standard pembelajaran yang anda berikan, dan tidak menambah perkara lain?",
          "Adakah masa setiap aktiviti munasabah untuk satu waktu sebenar di kelas anda?",
          "Adakah aktiviti boleh dilaksanakan dengan peralatan dan ruang yang ada?",
          "Adakah istilah dan ejaan sepadan dengan buku teks dan Bahasa Melayu baku?",
          "Adakah fakta dalam set induksi atau contoh yang dicadangkan betul?"
        ]
      },
      {
        "p": [
          "AI boleh tersilap fakta dengan yakin, dan ia juga boleh menulis Bahasa Melayu yang berbunyi seperti terjemahan. Bacaan pantas lima minit biasanya cukup untuk mengesan masalah ini."
        ]
      },
      {
        "h2": "Jaga maklumat murid",
        "p": [
          "RPH memerlukan konteks kelas, tetapi bukan maklumat peribadi. Tulis \"beberapa murid lemah membaca\" dan bukannya nama murid. Jangan masukkan markah individu, catatan disiplin atau maklumat kesihatan ke dalam gesaan. Ikut juga garis panduan sekolah dan pihak berkuasa pendidikan tentang penggunaan alat AI, dan bincangkan bersama panitia jika belum jelas."
        ]
      },
      {
        "h2": "Aliran kerja mingguan yang ringkas",
        "p": [
          "Cara ini boleh anda cuba untuk satu minggu sebelum memutuskan sama ada ia sesuai:"
        ],
        "list": [
          "Pada awal minggu, kumpulkan standard pembelajaran untuk setiap waktu daripada DSKP dan rancangan tahunan.",
          "Gunakan satu gesaan yang sama untuk setiap waktu, dengan hanya standard dan konteks kelas yang berubah.",
          "Semak dan ubah suai setiap draf mengikut senarai semak di atas.",
          "Selepas kelas, tulis catatan ringkas dan minta AI menyusunnya menjadi draf refleksi, kemudian betulkan mengikut apa yang benar-benar berlaku."
        ]
      },
      {
        "p": [
          "Prinsip ini tidak terikat kepada satu alat. Ia terpakai sama ada anda menggunakan aplikasi RPH AI khusus, ChatGPT, atau platform seperti Bicarra yang membolehkan anda memilih model daripada beberapa syarikat AI. Yang penting ialah bahan yang anda beri dan semakan yang anda buat."
        ]
      },
      {
        "h2": "Ringkasnya",
        "p": [
          "RPH AI paling berguna sebagai pembantu draf. Mulakan dengan standard pembelajaran daripada DSKP, beri konteks kelas tanpa maklumat peribadi, minta format yang jelas, dan semak setiap draf sebelum digunakan. Dengan cara itu anda menjimatkan masa menulis, sementara keputusan tentang apa dan bagaimana murid belajar kekal di tangan guru."
        ]
      }
    ]
  },
  {
    "slug": "chatgpt-untuk-guru-menulis-gesaan",
    "category": "panduan",
    "eyebrow": "Panduan pendidikan",
    "date": "2026-10-19",
    "readMinutes": 5,
    "art": "guide",
    "title": "ChatGPT untuk guru: cara menulis gesaan yang memberi hasil boleh guna.",
    "excerpt": "Ramai guru mencuba ChatGPT, mendapat jawapan yang terlalu umum, lalu berhenti. Masalahnya selalu pada gesaan. Panduan ringkas menulis gesaan yang jelas, dengan contoh untuk kerja harian guru.",
    "body": [
      {
        "p": [
          "Ramai guru pernah mencuba ChatGPT sekali dua. Taip \"buat nota tentang ekosistem\", tunggu beberapa saat, dan dapat sesuatu yang kemas tetapi terlalu umum: tidak sesuai dengan tahap murid, tidak ikut istilah buku teks, dan terlalu panjang untuk satu waktu. Selepas itu ramai yang membuat kesimpulan bahawa alat ini tidak berguna untuk kelas mereka.",
          "Selalunya masalahnya bukan pada alat itu, tetapi pada arahan yang diberi. Arahan kepada chatbot ini dipanggil gesaan (prompt). Gesaan yang kabur menghasilkan jawapan yang kabur. Artikel ini menerangkan cara menulis gesaan yang lebih jelas, dengan contoh yang boleh anda suai untuk kerja harian. Prinsipnya terpakai pada ChatGPT dan juga chatbot AI lain yang serupa."
        ]
      },
      {
        "h2": "Kenapa jawapan pertama selalunya mengecewakan",
        "p": [
          "Chatbot tidak tahu siapa anda, siapa murid anda, atau apa yang sudah diajar minggu lepas. Bila maklumat itu tiada, ia mengisi kekosongan dengan andaian yang paling umum. Hasilnya bahan yang sesuai untuk \"semua orang\", dan oleh itu kurang sesuai untuk kelas anda.",
          "Bayangkan anda meminta bantuan seorang guru ganti yang tidak pernah masuk ke sekolah anda. Anda tidak akan sekadar berkata \"ajar sains\". Anda akan memberitahu tahun berapa, topik apa, apa yang murid sudah tahu, dan berapa lama masa yang ada. Gesaan yang baik memberi maklumat yang sama."
        ]
      },
      {
        "h2": "Lima unsur gesaan yang jelas",
        "p": [
          "Anda tidak perlu menghafal formula. Cukup pastikan gesaan anda menjawab lima perkara ini:"
        ],
        "list": [
          "Peranan: siapa chatbot itu patut bertindak sebagai, contohnya guru Sains Tahun 5 yang berpengalaman.",
          "Konteks: siapa murid anda, tahap mereka, dan apa yang sudah mereka pelajari.",
          "Tugas: apa sebenarnya yang anda mahu dihasilkan, dalam satu atau dua ayat yang tepat.",
          "Bahan: nota, petikan buku teks atau senarai istilah yang mesti dijadikan asas.",
          "Format: panjang, susunan dan bentuk hasil, contohnya jadual, senarai bernombor atau lima soalan pendek."
        ]
      },
      {
        "p": [
          "Unsur yang paling kerap dilupakan ialah bahan. Bila anda memberi bahan sendiri, chatbot bekerja daripada sumber yang anda percaya, bukan daripada ingatan amnya. Ini mengurangkan risiko fakta yang salah dan istilah yang tidak sepadan dengan buku teks."
        ]
      },
      {
        "h2": "Contoh: daripada gesaan kabur kepada gesaan jelas",
        "p": [
          "Gesaan kabur: \"Terangkan rantai makanan.\"",
          "Gesaan jelas: \"Anda guru Sains Tahun 5. Murid saya sudah belajar tentang pengeluar dan pengguna, tetapi masih keliru tentang arah anak panah dalam rantai makanan. Berdasarkan nota di bawah, tulis penerangan ringkas tidak lebih 120 patah perkataan dalam Bahasa Melayu yang mudah, diikuti dua contoh rantai makanan dari persekitaran Malaysia. Gunakan istilah pengeluar, pengguna primer dan pengguna sekunder. Nota: ...\"",
          "Gesaan kedua lebih panjang, tetapi ia menjimatkan masa kerana hasilnya lebih hampir kepada apa yang anda mahukan sejak cubaan pertama."
        ]
      },
      {
        "h2": "Gesaan untuk kerja harian guru",
        "p": [
          "Berikut beberapa pola yang boleh anda salin dan suai. Gantikan bahagian dalam kurungan dengan maklumat anda sendiri."
        ],
        "list": [
          "Nota ringkas: \"Ringkaskan petikan di bawah kepada lima isi utama untuk murid [tahun], setiap isi satu ayat, dalam Bahasa Melayu yang mudah.\"",
          "Penerangan alternatif: \"Murid saya tidak faham [konsep] melalui penerangan biasa. Beri tiga cara berbeza untuk menerangkannya, satu menggunakan contoh harian, satu menggunakan analogi, dan satu menggunakan langkah demi langkah.\"",
          "Rubrik: \"Sediakan rubrik empat tahap untuk tugasan [jenis tugasan] berdasarkan kriteria di bawah. Paparkan dalam jadual.\"",
          "Aktiviti kelas: \"Cadangkan dua aktiviti berkumpulan selama 15 minit untuk mengukuhkan [topik] dalam kelas seramai [bilangan] murid, tanpa memerlukan peranti.\"",
          "Surat makluman: \"Tulis draf ringkas makluman kepada ibu bapa tentang [perkara], dengan nada sopan dan jelas, tidak lebih satu perenggan.\""
        ]
      },
      {
        "p": [
          "Untuk menjana soalan latihan, ada panduan khusus dalam artikel kami tentang chatbot soalan untuk guru, termasuk cara menetapkan aras kognitif."
        ]
      },
      {
        "h2": "Jangan berhenti pada jawapan pertama",
        "p": [
          "Kelebihan chatbot ialah anda boleh berbual dengannya. Jawapan pertama ialah draf, bukan hasil akhir. Minta ia membetulkan bahagian tertentu, dan bukannya menulis semula gesaan dari awal.",
          "Contoh susulan yang berguna: \"Pendekkan kepada separuh.\" \"Gunakan ayat yang lebih mudah untuk murid yang lemah membaca.\" \"Gantikan contoh kedua dengan sesuatu dari kawasan luar bandar.\" \"Tukar perkataan ini kepada istilah buku teks.\" Dua atau tiga pusingan susulan biasanya cukup untuk mendapat bahan yang sedia disemak."
        ]
      },
      {
        "h2": "Apa yang tidak patut dimasukkan ke dalam gesaan",
        "p": [
          "Gesaan yang baik memerlukan konteks, tetapi bukan maklumat peribadi. Anda boleh menyebut \"murid yang lemah membaca\" tanpa menyebut nama sesiapa. Jangan masukkan nama murid, markah individu, catatan disiplin atau maklumat kesihatan. Semua itu tidak diperlukan untuk menghasilkan bahan pengajaran yang baik.",
          "Ikut juga garis panduan sekolah dan pihak berkuasa pendidikan anda tentang penggunaan alat AI. Kalau belum jelas, bincangkan bersama panitia sebelum ia digunakan secara meluas."
        ]
      },
      {
        "h2": "Semak sebelum digunakan",
        "p": [
          "Gesaan yang baik meningkatkan mutu hasil, tetapi tidak menjamin ketepatannya. Chatbot masih boleh tersilap fakta, tersasar istilah atau menulis Bahasa Melayu yang berbunyi seperti terjemahan. Baca setiap hasil sebelum sampai kepada murid. Semakan ialah bahagian kerja yang tetap milik guru.",
          "Prinsip gesaan dalam artikel ini tidak terikat kepada satu alat. Ia terpakai sama ada anda menggunakan ChatGPT, chatbot lain, atau platform seperti Bicarra yang membolehkan anda memilih model daripada beberapa syarikat AI."
        ]
      },
      {
        "h2": "Ringkasnya",
        "p": [
          "ChatGPT untuk guru paling berguna bila diberi arahan seperti anda memberi arahan kepada guru ganti: jelas tentang murid, tugas, bahan dan format. Tulis gesaan yang lengkap, perbaiki melalui susulan, jaga maklumat murid, dan semak setiap hasil. Dengan cara itu, alat ini menjadi pembantu draf yang menjimatkan masa, bukan sumber kerja tambahan."
        ]
      }
    ]
  },
  {
    "slug": "ai-dalam-pendidikan-panduan-guru",
    "category": "panduan",
    "eyebrow": "Panduan pendidikan",
    "date": "2026-10-12",
    "readMinutes": 4,
    "art": "checklist",
    "title": "AI dalam pendidikan: apa yang benar-benar membantu guru, dan apa yang tetap kerja guru.",
    "excerpt": "AI dalam pendidikan bukan lagi cerita masa depan. Panduan ringkas untuk guru: di mana AI menjimatkan masa, di mana ia perlu diawasi, dan bagaimana bermula dengan selamat.",
    "body": [
      {
        "p": [
          "Frasa \"AI dalam pendidikan\" kini muncul dalam mesyuarat sekolah, kursus dalam perkhidmatan dan perbualan bilik guru. Ada yang teruja, ada yang risau, dan ramai yang sekadar ingin tahu: apa sebenarnya yang boleh dibuat oleh AI untuk seorang guru biasa, minggu ini, dengan kelas yang sedia ada?",
          "Artikel ini tidak cuba meramal masa depan. Ia memberi gambaran praktikal tentang di mana alat AI, terutamanya chatbot, boleh membantu kerja harian guru, di mana ia perlu diawasi dengan rapi, dan bagaimana bermula tanpa menjejaskan murid."
        ]
      },
      {
        "h2": "AI ialah pembantu, bukan pengganti",
        "p": [
          "Cara paling sihat untuk memikirkan AI ialah sebagai pembantu yang pantas menulis tetapi tidak mengenali murid anda. Ia boleh menyediakan draf, meringkaskan bahan dan mencadangkan idea. Ia tidak tahu murid mana yang baru kehilangan ibu bapa, kelas mana yang perlukan contoh lebih konkrit, atau kenapa satu topik selalu gagal difahami pada waktu petang.",
          "Pengetahuan tentang konteks itulah kerja guru. AI boleh mengurangkan masa menaip, tetapi keputusan tentang apa yang diajar, bagaimana dan kepada siapa tetap milik anda."
        ]
      },
      {
        "h2": "Di mana AI biasanya membantu",
        "p": [
          "Kerja yang paling sesuai untuk AI ialah kerja yang berulang, banyak bergantung pada teks, dan mudah anda semak sendiri. Antara contohnya:"
        ],
        "list": [
          "Menyediakan draf soalan latihan atau kuiz berdasarkan nota yang anda berikan",
          "Meringkaskan petikan panjang kepada beberapa isi utama untuk nota murid",
          "Mencadangkan beberapa cara berbeza untuk menerangkan satu konsep yang sukar",
          "Menyediakan draf surat makluman kepada ibu bapa yang kemudian anda suai sendiri",
          "Menjawab soalan lazim yang berulang, seperti jadual, prosedur atau senarai bahan, berdasarkan maklumat yang anda sediakan"
        ]
      },
      {
        "p": [
          "Dalam setiap contoh di atas, AI menghasilkan draf dan anda menyemak. Kalau sesuatu kerja tidak dapat anda semak dengan mudah, itu tanda ia belum sesuai diserahkan kepada AI."
        ]
      },
      {
        "h2": "Di mana AI perlu diawasi",
        "p": [
          "Chatbot AI boleh menulis dengan yakin walaupun isinya salah. Ini bukan kecacatan yang jarang berlaku, tetapi sifat cara alat ini berfungsi. Ia menghasilkan ayat yang kedengaran munasabah, bukan semestinya ayat yang tepat.",
          "Beri perhatian khusus kepada perkara berikut:"
        ],
        "list": [
          "Fakta, tarikh, nama dan angka, yang perlu disemak dengan buku teks atau sumber rasmi",
          "Istilah mata pelajaran, yang mungkin berbeza daripada istilah yang murid jumpa di kelas",
          "Aras kognitif soalan, kerana AI cenderung menghasilkan soalan mengingat walaupun diminta soalan aras tinggi",
          "Bahasa Melayu yang berbunyi seperti terjemahan daripada Bahasa Inggeris",
          "Kandungan yang menyentuh agama, budaya atau isu sensitif, yang memerlukan pertimbangan guru"
        ]
      },
      {
        "p": [
          "Semakan ini tidak perlu mengambil masa yang lama. Bagi kebanyakan bahan, membaca sekali dengan teliti sudah memadai untuk mengesan kesilapan yang jelas. Yang penting ialah semakan itu dibuat setiap kali, bukan hanya apabila anda berasa ragu-ragu, kerana kesilapan AI selalunya muncul pada bahagian yang kelihatan paling meyakinkan."
        ]
      },
      {
        "h2": "Jaga maklumat murid",
        "p": [
          "Peraturan paling mudah: jangan masukkan maklumat peribadi murid ke dalam alat AI. Nama, markah, catatan disiplin dan maklumat kesihatan tidak diperlukan untuk menyediakan bahan pengajaran. Gunakan bahan am, dan buang butiran yang boleh mengenal pasti seseorang sebelum meminta bantuan AI.",
          "Ikut juga garis panduan sekolah dan pihak berkuasa pendidikan anda. Kalau belum ada garis panduan yang jelas di sekolah anda, itu topik yang wajar dibawa ke mesyuarat panitia.",
          "Bagi sekolah atau organisasi yang mahukan kawalan lebih ketat terhadap ke mana data pergi, sesetengah platform membenarkan model AI dijalankan pada perkakasan sendiri. Bicarra, sebagai contoh, boleh disambungkan kepada model yang dijalankan melalui Ollama, LM Studio atau vLLM, supaya perbualan tidak meninggalkan perkakasan anda sendiri. Pilihan ini tidak perlu untuk semua orang, tetapi baik untuk diketahui."
        ]
      },
      {
        "h2": "Bahasa Melayu tetap penting",
        "p": [
          "Banyak alat AI dibina dengan Bahasa Inggeris sebagai bahasa utama. Bila diminta menulis dalam Bahasa Melayu, hasilnya kadang-kadang betul dari segi tatabahasa tetapi janggal dari segi gaya, atau memakai istilah yang tidak digunakan dalam sistem pendidikan kita.",
          "Cara menyemaknya mudah: baca hasilnya dengan kuat. Kalau anda sendiri tidak akan menulisnya begitu, murid juga mungkin tersekat. Berikan senarai istilah yang anda mahu, dan minta AI menulis semula. Bahan yang jelas bahasanya membolehkan murid menumpukan perhatian kepada isi pelajaran."
        ]
      },
      {
        "h2": "Cara bermula dengan selamat",
        "p": [
          "Tidak perlu mengubah seluruh cara mengajar. Mulakan kecil, dengan kerja berisiko rendah, dan perhatikan hasilnya."
        ],
        "list": [
          "Pilih satu tugas yang berulang setiap minggu, contohnya menyediakan latihan pengukuhan.",
          "Sediakan bahan sumber yang anda sendiri percaya, seperti nota atau petikan buku teks.",
          "Minta AI menghasilkan draf berdasarkan bahan itu sahaja.",
          "Semak setiap hasil sebelum digunakan, dan catat jenis kesilapan yang berulang.",
          "Kongsi pengalaman dengan rakan panitia supaya semua belajar daripada kesilapan yang sama."
        ]
      },
      {
        "p": [
          "Selepas beberapa minggu, anda akan tahu dengan lebih jelas tugas mana yang benar-benar menjimatkan masa dan tugas mana yang lebih cepat dibuat sendiri."
        ]
      },
      {
        "h2": "Ringkasnya",
        "p": [
          "AI dalam pendidikan paling berguna bila ia mengambil alih kerja menaip yang berulang, supaya guru ada lebih masa untuk kerja yang hanya guru boleh buat: memahami murid, membuat pertimbangan dan membimbing. Gunakan AI untuk draf. Kekalkan guru sebagai penentu mutu."
        ]
      }
    ]
  },
  {
    "slug": "chatbot-soalan-untuk-guru",
    "category": "panduan",
    "eyebrow": "Panduan pendidikan",
    "date": "2026-10-05",
    "readMinutes": 5,
    "art": "guide",
    "title": "Chatbot soalan: cara guru menjana soalan latihan yang boleh dipercayai.",
    "excerpt": "Chatbot AI boleh membantu guru menyediakan draf soalan latihan dengan cepat. Begini cara menggunakannya supaya soalan selari dengan sukatan, tepat aras, dan tetap disemak oleh guru.",
    "body": [
      {
        "p": [
          "Ramai guru kini mencari \"chatbot soalan\" dengan satu harapan: menyediakan soalan latihan, kuiz atau draf soalan ujian dengan lebih cepat. Harapan itu munasabah. Chatbot AI memang pantas menghasilkan ayat, dan kerja menyediakan soalan memang memakan masa, terutamanya bila anda perlukan beberapa versi untuk kelas yang berbeza tahap.",
          "Tetapi soalan yang cepat dijana tidak semestinya soalan yang baik. Artikel ini menerangkan cara menggunakan chatbot untuk menyediakan soalan dengan cara yang menjimatkan masa tanpa menjejaskan mutu, dan di mana pertimbangan guru tetap tidak boleh diganti."
        ]
      },
      {
        "h2": "Dua maksud \"chatbot soalan\"",
        "p": [
          "Istilah ini sebenarnya membawa dua maksud. Pertama, chatbot yang menjana soalan, iaitu anda memberi topik dan ia menghasilkan soalan latihan. Kedua, chatbot yang menjawab soalan, iaitu ia menjawab pertanyaan murid, ibu bapa atau rakan sekerja berdasarkan maklumat yang anda sediakan.",
          "Kedua-duanya berguna, tetapi caranya berbeza. Artikel ini menumpukan maksud pertama. Kalau anda lebih memerlukan maksud kedua, seperti menjawab soalan lazim yang berulang setiap penggal, prinsip di bawah tentang memberi bahan rujukan yang kemas tetap terpakai."
        ]
      },
      {
        "h2": "Mulakan dengan bahan anda, bukan dengan topik kosong",
        "p": [
          "Kesilapan paling biasa ialah menaip arahan yang terlalu umum, contohnya \"buat 10 soalan Sains Tingkatan 2\". Chatbot akan menjawab, tetapi ia meneka skop berdasarkan pengetahuan am, bukan berdasarkan apa yang anda ajar minggu ini.",
          "Hasil yang jauh lebih baik datang bila anda memberi konteks yang jelas:"
        ],
        "list": [
          "Standard kandungan dan standard pembelajaran yang ingin diuji",
          "Petikan nota, buku teks atau lembaran kerja yang telah anda gunakan di kelas",
          "Tahap murid, contohnya kelas yang masih membina asas atau kelas yang sudah bersedia untuk soalan aras tinggi",
          "Bentuk soalan yang dikehendaki, sama ada objektif, struktur atau esei pendek"
        ]
      },
      {
        "p": [
          "Bila chatbot menjana soalan berdasarkan bahan yang anda beri, soalan itu lebih dekat dengan apa yang murid benar-benar pelajari. Ia juga lebih mudah anda semak kerana anda tahu sumbernya."
        ]
      },
      {
        "h2": "Tetapkan aras kognitif secara jelas",
        "p": [
          "Chatbot cenderung menghasilkan soalan aras rendah, seperti mengingat fakta dan memberi definisi, kerana soalan jenis itu paling mudah dibina. Kalau anda mahukan soalan aplikasi, analisis atau penilaian, nyatakannya dengan jelas dalam arahan.",
          "Satu cara yang berkesan ialah meminta chatbot melabel setiap soalan dengan aras yang dimaksudkan, kemudian anda semak sama ada label itu betul. Anda akan dapati sebahagian soalan yang dilabel \"analisis\" sebenarnya hanya soalan mengingat yang ditulis dengan ayat lebih panjang. Semakan ini penting, terutamanya bila soalan akan digunakan untuk menyusun ujian mengikut Jadual Spesifikasi Ujian (JSU) sekolah anda."
        ]
      },
      {
        "h2": "Semak setiap soalan sebelum sampai kepada murid",
        "p": [
          "Ini peraturan yang tidak boleh dilangkau. Chatbot AI boleh menghasilkan soalan yang kedengaran betul tetapi mengandungi kesilapan fakta, pilihan jawapan yang lebih daripada satu betul, atau istilah yang tidak sama dengan buku teks.",
          "Sebelum menggunakan mana-mana soalan, semak perkara berikut:"
        ],
        "list": [
          "Adakah fakta dan jawapannya tepat mengikut sukatan yang anda ajar?",
          "Untuk soalan objektif, adakah hanya satu jawapan yang betul, dan adakah pilihan pengganggu munasabah?",
          "Adakah istilahnya sama dengan istilah yang murid jumpa dalam buku teks dan di kelas?",
          "Adakah bahasanya jelas dan sesuai dengan tahap murid?",
          "Adakah soalan itu benar-benar menguji kemahiran yang dimaksudkan?"
        ]
      },
      {
        "p": [
          "Anggap hasil chatbot sebagai draf pertama daripada pembantu yang rajin tetapi belum mengenali kelas anda. Draf itu menjimatkan masa menaip. Keputusan tentang soalan mana yang layak digunakan tetap milik anda."
        ]
      },
      {
        "h2": "Bahasa Melayu yang betul-betul Bahasa Melayu",
        "p": [
          "Banyak alat AI dibina dengan Bahasa Inggeris sebagai bahasa utama. Bila diminta menulis soalan dalam Bahasa Melayu, hasilnya kadang-kadang berbunyi seperti terjemahan: struktur ayat janggal, atau istilah yang tidak digunakan dalam sistem pendidikan kita.",
          "Cara menyemaknya mudah. Baca soalan itu dengan kuat. Kalau anda sendiri tidak akan menulisnya begitu, murid juga akan tersekat. Mintalah chatbot menulis semula dengan istilah yang anda berikan, atau betulkan sendiri. Soalan yang mengelirukan dari segi bahasa menguji kefahaman bahasa, bukan kefahaman topik."
        ]
      },
      {
        "h2": "Jaga maklumat murid",
        "p": [
          "Menjana soalan jarang memerlukan maklumat peribadi murid, jadi jangan masukkan nama, markah atau catatan murid ke dalam chatbot. Gunakan bahan pengajaran am sahaja.",
          "Kalau sekolah atau organisasi anda mahukan kawalan lebih ketat terhadap ke mana bahan pergi, sesetengah platform membenarkan model AI dijalankan sendiri. Bicarra, sebagai contoh, boleh disambungkan kepada model yang dijalankan melalui Ollama, LM Studio atau vLLM, supaya perbualan tidak meninggalkan perkakasan anda sendiri. Ini bukan keperluan untuk semua orang, tetapi ia pilihan yang wujud."
        ]
      },
      {
        "h2": "Aliran kerja ringkas yang boleh anda cuba minggu ini",
        "list": [
          "Pilih satu topik kecil yang baru anda ajar.",
          "Sediakan petikan nota atau bahan yang telah digunakan di kelas.",
          "Minta chatbot menghasilkan lima soalan, dengan aras kognitif dan jawapan untuk setiap satu.",
          "Semak setiap soalan menggunakan senarai di atas, dan buang atau betulkan yang lemah.",
          "Gunakan soalan yang lulus semakan sebagai latihan, kemudian perhatikan di mana murid tersekat."
        ]
      },
      {
        "p": [
          "Mulakan dengan latihan berisiko rendah, bukan ujian rasmi. Bila anda sudah biasa dengan corak kesilapan chatbot yang anda guna, barulah luaskan penggunaannya."
        ]
      },
      {
        "h2": "Ringkasnya",
        "p": [
          "Chatbot soalan boleh menjadi pembantu yang berguna untuk guru, dengan syarat ia diberi bahan yang jelas, diarahkan dengan aras kognitif yang tepat, dan setiap hasilnya disemak sebelum sampai kepada murid. Chatbot mempercepatkan draf. Guru menentukan mutu."
        ]
      }
    ]
  },
  {
    "slug": "ai-chatbot-untuk-guru",
    "category": "panduan",
    "eyebrow": "Panduan pendidikan",
    "date": "2026-10-05",
    "readMinutes": 4,
    "art": "checklist",
    "title": "AI chatbot untuk guru: lima perkara untuk disemak sebelum mula.",
    "excerpt": "Sebelum memilih AI chatbot untuk kerja sekolah, semak lima perkara ini: sumber jawapan, Bahasa Melayu, keselamatan bahan, pilihan model, dan siapa yang menyemak.",
    "body": [
      {
        "p": [
          "Semakin ramai guru mencari \"AI chatbot guru\" dan menemui senarai panjang aplikasi, laman percuma dan hantaran media sosial yang mengesyorkan alat demi alat. Senarai begitu membantu untuk tahu apa yang wujud. Tetapi ia jarang menjawab soalan yang lebih penting: alat mana yang sesuai dengan cara anda bekerja, dan apa yang perlu anda semak sebelum memasukkan bahan sekolah ke dalamnya.",
          "Artikel ini bukan senarai aplikasi. Ia senarai semak ringkas yang boleh anda guna pada mana-mana chatbot AI, sama ada pembantu umum atau chatbot yang anda bina sendiri."
        ]
      },
      {
        "h2": "1. Dari mana jawapannya datang?",
        "p": [
          "Ini soalan pertama dan paling penting. Chatbot umum menjawab berdasarkan apa yang model itu pelajari secara am. Ia boleh menerangkan konsep dengan baik, tetapi ia tidak tahu apa yang sekolah anda putuskan dalam mesyuarat panitia minggu lepas, atau format yang ketua bidang anda mahu.",
          "Chatbot yang diberi dokumen anda sendiri berfungsi secara berbeza. Ia menjawab berdasarkan bahan yang anda kongsikan, seperti garis panduan, soalan lazim atau nota rujukan. Untuk soalan yang jawapannya sudah tetap dan sudah ditulis, pendekatan ini lebih boleh dipercayai.",
          "Semak juga apa yang berlaku bila soalan berada di luar bahan yang diberi. Chatbot yang baik sepatutnya mengaku tidak pasti dan mencadangkan anda bertanya kepada orang yang betul, bukan mereka jawapan yang kedengaran yakin."
        ]
      },
      {
        "h2": "2. Adakah ia benar-benar faham Bahasa Melayu?",
        "p": [
          "Banyak alat AI dibina dalam Bahasa Inggeris, kemudian diterjemah. Hasilnya boleh difahami, tetapi selalunya janggal, dan istilah pendidikan kerap tersasar. \"Pentaksiran bilik darjah\", \"objektif pembelajaran\" dan \"aktiviti pengayaan\" ada makna khusus dalam konteks sekolah kita.",
          "Cara menyemaknya mudah. Tanya chatbot itu tiga atau empat soalan dalam Bahasa Melayu yang biasa anda tanya kepada rakan sekerja. Baca jawapannya dengan kuat. Kalau bunyinya seperti terjemahan, murid dan ibu bapa juga akan perasan."
        ]
      },
      {
        "h2": "3. Ke mana bahan anda pergi?",
        "p": [
          "Guru mengendalikan banyak maklumat yang tidak sepatutnya tersebar: nama murid, markah, catatan disiplin, surat dalaman. Sebelum menampal apa-apa ke dalam chatbot, tanya diri anda: kalau teks ini dibaca oleh orang luar, adakah ia menjadi masalah?",
          "Peraturan paling selamat ialah jangan masukkan maklumat peribadi murid ke dalam mana-mana alat AI yang anda tidak kawal. Gunakan chatbot untuk bahan am dan bahan rujukan, bukan rekod murid.",
          "Untuk sekolah atau organisasi yang lebih berhati-hati, ada juga pilihan menjalankan model AI sendiri. Sesetengah platform, termasuk Bicarra, boleh disambungkan kepada model yang dijalankan melalui Ollama, LM Studio atau vLLM, supaya perbualan tidak meninggalkan perkakasan anda sendiri. Ini bukan keperluan untuk semua orang, tetapi ia pilihan yang wujud."
        ]
      },
      {
        "h2": "4. Adakah anda terikat kepada satu syarikat AI?",
        "p": [
          "Model AI berubah dengan cepat. Model yang terbaik untuk Bahasa Melayu hari ini mungkin bukan yang terbaik tahun depan. Kalau alat yang anda pilih hanya boleh menggunakan satu model, anda terpaksa ikut apa sahaja keputusan syarikat itu.",
          "Semak sama ada alat itu membenarkan anda menukar model tanpa membina semula semuanya. Bicarra, sebagai contoh, boleh disambungkan kepada lebih 400 model daripada lebih 60 makmal AI melalui satu kunci OpenRouter, atau terus kepada penyedia seperti OpenAI, Anthropic dan Google. Apa pun alat yang anda pilih, prinsipnya sama: jangan biarkan bahan dan kerja anda terkunci pada satu pilihan."
        ]
      },
      {
        "h2": "5. Siapa yang akan menyemak jawapannya?",
        "p": [
          "Chatbot AI boleh menjimatkan masa, tetapi ia tidak menggantikan pertimbangan profesional guru. Ia tidak mengenali kelas anda, tahap murid anda, atau apa yang berlaku di sekolah minggu ini.",
          "Tetapkan sempadan dari awal. Chatbot sesuai untuk:"
        ],
        "list": [
          "Menjawab soalan rujukan yang jawapannya sudah didokumenkan",
          "Menyediakan draf awal yang anda akan semak dan ubah",
          "Menerangkan konsep dengan cara lain bila anda perlukan sudut baharu"
        ]
      },
      {
        "p": [
          "Ia kurang sesuai untuk:"
        ],
        "list": [
          "Membuat keputusan tentang murid tertentu",
          "Menilai kerja murid tanpa semakan guru",
          "Memberi maklumat rasmi yang belum anda sahkan sendiri"
        ]
      },
      {
        "p": [
          "Kalau chatbot akan digunakan oleh orang lain, seperti guru baharu atau ibu bapa, pastikan ada seseorang yang bertanggungjawab menyemak dan mengemas kini bahannya secara berkala."
        ]
      },
      {
        "h2": "Cara mencuba tanpa membazir masa",
        "p": [
          "Anda tidak perlu memilih alat yang sempurna pada hari pertama. Mulakan dengan satu tugas kecil yang berulang, contohnya soalan yang anda jawab berkali-kali setiap penggal.",
          "Sediakan bahan rujukan yang kemas untuk tugas itu. Kemudian uji chatbot dengan soalan sebenar, dalam ayat yang orang sebenar akan guna, termasuk soalan yang sengaja berada di luar bahan anda. Perhatikan tiga perkara: adakah jawapannya tepat, adakah bahasanya sesuai, dan adakah ia tahu bila perlu berkata \"saya tidak pasti\".",
          "Kalau ketiga-tiganya memuaskan, barulah luaskan kepada tugas lain. Kalau tidak, anda hanya kehilangan beberapa jam, bukan satu penggal."
        ]
      },
      {
        "h2": "Ringkasnya",
        "p": [
          "Sebelum memilih AI chatbot untuk kerja guru, semak lima perkara ini: dari mana jawapannya datang, sejauh mana ia faham Bahasa Melayu, ke mana bahan anda pergi, sama ada anda terikat kepada satu model, dan siapa yang menyemak jawapannya. Alat yang lulus kelima-limanya akan menjimatkan masa anda. Alat yang gagal walaupun satu boleh menambah kerja yang anda cuba kurangkan."
        ]
      }
    ]
  },
  {
    "slug": "chatbot-rph-panitia",
    "category": "panduan",
    "eyebrow": "Panduan pendidikan",
    "date": "2026-10-05",
    "readMinutes": 5,
    "art": "guide",
    "title": "Chatbot RPH: bantu panitia jawab soalan berulang guru baharu.",
    "excerpt": "Guru baharu sering bertanya perkara sama tentang format RPH. Begini cara panitia boleh sediakan pembantu AI yang menjawabnya daripada dokumen sekolah sendiri.",
    "body": [
      {
        "p": [
          "Setiap kali sesi baharu bermula, panitia hampir pasti menerima soalan yang sama daripada guru baharu atau guru pelatih: apa format RPH terkini yang sekolah guna, bahagian mana wajib ada refleksi, dan macam mana nak selaraskan dengan templat panitia sendiri. Semakin ramai guru kini mencari bantuan AI untuk kerja jenis ini, dan itulah sebabnya carian seperti \"chatbot RPH\" semakin kerap dilihat.",
          "Artikel ini bukan tentang chatbot yang menulis RPH bagi pihak anda. Ia tentang sesuatu yang lebih spesifik dan lebih boleh dipercayai: chatbot yang dilatih dengan dokumen panitia anda sendiri, supaya soalan rujukan yang berulang boleh dijawab tanpa mengganggu guru kanan setiap kali."
        ]
      },
      {
        "h2": "Soalan yang sama, bertahun-tahun",
        "p": [
          "Bukan kandungan RPH itu sendiri yang selalunya jadi masalah. Ia lebih kepada soalan pentadbiran di sekelilingnya, soalan yang panitia sudah jawab berkali-kali:"
        ],
        "list": [
          "Format terkini yang sekolah kita guna, KSSM atau KSSR, versi mana",
          "Bahagian refleksi wajib ada elemen apa",
          "Templat panitia yang mana perlu diguna untuk mata pelajaran ini",
          "Cara dan tarikh hantar untuk semakan ketua panitia"
        ]
      },
      {
        "p": [
          "Guru baharu bertanya kerana mereka belum biasa. Guru lama menjawab kerana mereka satu-satunya yang ingat semua butiran ini. Lama-kelamaan, ini menjadi kerja sampingan yang memakan masa yang sepatutnya untuk mengajar dan merancang."
        ]
      },
      {
        "h2": "Apa yang chatbot patut, dan tidak patut, buat",
        "p": [
          "Penting untuk jelas di sini. Chatbot AI tidak sepatutnya mereka isi kandungan pengajaran atau membuat pertimbangan profesional bagi pihak guru. Itu kekal tugas guru, kerana ia memerlukan pemahaman tentang kelas dan pelajar sebenar.",
          "Apa yang sesuai untuk chatbot ialah soalan rujukan pantas: format apa yang diguna, dokumen mana yang perlu dirujuk, siapa perlu dihubungi untuk kelulusan. Ini soalan yang jawapannya sudah tetap dan sudah didokumenkan, cuma belum senang dicapai bila diperlukan."
        ]
      },
      {
        "h2": "Bagaimana ia berfungsi: latih dengan dokumen panitia sendiri",
        "p": [
          "Chatbot seperti Bicarra berfungsi dengan cara yang mudah. Anda kongsikan dokumen sekolah atau panitia sendiri, seperti garis panduan format RPH, surat pekeliling berkaitan, atau senarai soalan lazim yang selalu ditanya guru baharu. Tiada pengekodan diperlukan.",
          "Selepas itu, chatbot menjawab berdasarkan dokumen yang anda beri, bukan mereka-reka jawapan sendiri. Kalau soalan berada di luar apa yang didokumenkan, ia sepatutnya berkata tidak pasti dan menyarankan guru bertanya terus kepada ketua panitia. Ini lebih selamat daripada jawapan yang kedengaran yakin tetapi salah."
        ]
      },
      {
        "h2": "Contoh soalan yang sesuai dihantar kepada chatbot",
        "p": [
          "Untuk memudahkan bayangan, berikut contoh soalan yang sesuai dijawab oleh chatbot rujukan panitia, berbanding soalan yang masih perlu guru kanan sendiri jawab:"
        ],
        "list": [
          "Sesuai untuk chatbot: Format RPH sekolah kita ikut KSSM versi bila?",
          "Sesuai untuk chatbot: Bahagian refleksi kena ada apa sahaja?",
          "Sesuai untuk chatbot: Templat mana untuk mata pelajaran Sains tahun enam?",
          "Masih perlu guru kanan: Objektif pembelajaran yang sesuai untuk kelas saya minggu ini apa?",
          "Masih perlu guru kanan: Macam mana nak sesuaikan aktiviti untuk murid pemulihan?"
        ]
      },
      {
        "p": [
          "Garis pemisah ini penting. Chatbot menjimatkan masa pada soalan jenis pertama supaya guru kanan ada lebih masa untuk soalan jenis kedua, iaitu soalan yang benar-benar memerlukan pengalaman mengajar."
        ]
      },
      {
        "h2": "Kekal dalam Bahasa Melayu, bukan terjemahan",
        "p": [
          "Kebanyakan alat AI ditulis asalnya dalam Bahasa Inggeris kemudian diterjemah. Untuk konteks sekolah, ini terasa janggal, terutama bila istilah rasmi seperti \"refleksi\", \"objektif pembelajaran\" atau \"penilaian formatif\" perlu digunakan dengan tepat.",
          "Chatbot yang menjawab terus dalam Bahasa Melayu, bukan hasil terjemahan skrip Inggeris, lebih selesa dibaca oleh guru dan lebih tepat menggunakan istilah yang memang digunakan dalam dokumen rasmi sekolah."
        ]
      },
      {
        "h2": "Simpan dokumen sekolah dengan berhati-hati",
        "p": [
          "Dokumen panitia kadangkala mengandungi maklumat yang sekolah tidak mahu tersebar bebas, seperti surat pekeliling dalaman atau nota daripada mesyuarat. Kalau ini kebimbangan sekolah anda, sesetengah platform membenarkan anda menyambungkan model AI anda sendiri, dijalankan melalui perisian seperti Ollama, LM Studio atau vLLM, supaya perbualan tidak meninggalkan infrastruktur sekolah sendiri.",
          "Ini bukan wajib untuk semua panitia. Tetapi ia pilihan yang wujud untuk sekolah yang lebih berhati-hati dengan dokumen dalaman."
        ]
      },
      {
        "h2": "Bila sesuai untuk panitia anda mula",
        "p": [
          "Kalau panitia anda menjawab soalan format RPH yang sama lebih daripada beberapa kali setiap penggal, terutama daripada guru baharu atau guru pelatih, ini sudah sesuai untuk dipertimbangkan. Sebelum itu, luangkan masa mengumpulkan dokumen rujukan yang kemas terlebih dahulu, kerana chatbot hanya sebaik dokumen yang anda beri kepadanya.",
          "Mulakan kecil. Latih dengan satu set dokumen format RPH dan soalan lazim panitia anda, cuba sendiri seperti guru baharu akan tanya, dan lihat sama ada ia benar-benar menjimatkan masa sebelum diperluaskan kepada panitia lain."
        ]
      },
      {
        "h2": "Semak semula setiap penggal",
        "p": [
          "Format RPH dan garis panduan panitia boleh berubah dari semasa ke semasa, mengikut arahan terkini Kementerian atau keputusan mesyuarat panitia. Chatbot yang dilatih dengan dokumen lama akan terus menjawab berdasarkan dokumen lama itu, walaupun ia sudah tidak tepat.",
          "Jadikan ia sebahagian daripada rutin permulaan penggal: semak semula dokumen yang dikongsikan dengan chatbot, kemas kini mana-mana bahagian yang sudah berubah, dan buang dokumen yang sudah lapuk. Sepuluh minit pada permulaan setiap penggal sudah memadai untuk memastikan jawapan yang diberi kekal boleh dipercayai oleh guru baharu yang bertanya."
        ]
      }
    ]
  },
  {
    slug: "jawab-soalan-berulang",
    category: "khidmat",
    eyebrow: "Khidmat pelanggan",
    date: "2026-09-18",
    readMinutes: 5,
    art: "repeat",
    title: "Jawab soalan berulang. Luangkan masa untuk pelanggan.",
    excerpt:
      "Soalan yang sama setiap hari memakan masa yang sepatutnya untuk pelanggan yang benar-benar perlukan anda.",
    body: [
      {
        p: [
          "Ada dua jenis mesej masuk. Yang pertama boleh dijawab oleh sesiapa sahaja yang tahu maklumat asas perniagaan anda. Yang kedua memerlukan pertimbangan anda.",
          "Masalahnya, kedua-duanya masuk ke inbox yang sama dan bersaing untuk perhatian yang sama.",
        ],
      },
      {
        h2: "Asingkan yang rutin daripada yang penting",
        p: [
          "Soalan seperti ada stok lagi, berapa harga, boleh pos ke Sabah, semuanya ada jawapan tetap. Ia tidak memerlukan anda, cuma memerlukan maklumat.",
          "Soalan seperti pesanan saya rosak, atau saya perlukan sesuatu yang khas untuk majlis minggu depan, memerlukan anda. Di situlah nilai anda sebenarnya.",
        ],
      },
      {
        h2: "Apa yang berubah bila yang rutin dikendalikan",
        p: [
          "Pelanggan mendapat jawapan serta-merta walaupun pukul sebelas malam. Anda pula membuka inbox dan terus nampak mesej yang benar-benar memerlukan perhatian, bukan tercari-cari di celah lima belas soalan harga.",
        ],
      },
      {
        h2: "Pastikan laluan kepada manusia sentiasa terbuka",
        p: [
          "Automasi yang baik tidak menyekat pelanggan daripada bercakap dengan anda. Ia menapis, bukan menghalang.",
          "Pastikan pelanggan sentiasa boleh minta untuk bercakap dengan orang, dan pastikan permintaan itu benar-benar sampai kepada anda. Chatbot yang memerangkap pelanggan dalam pusingan jawapan automatik merosakkan lebih banyak daripada yang ia jimatkan.",
        ],
      },
      {
        h2: "Semak semula setiap bulan",
        p: [
          "Baca semula perbualan yang berlaku. Anda akan jumpa soalan baharu yang mula berulang, dan jawapan lama yang sudah tidak tepat kerana harga atau dasar sudah berubah.",
          "Sepuluh minit sebulan sudah memadai untuk memastikan ia kekal berguna.",
        ],
      },
    ],
  },
  {
    slug: "bahasa-mesra-jawapan-beradab",
    category: "adab",
    eyebrow: "Bahasa & adab",
    date: "2026-09-15",
    readMinutes: 5,
    art: "language",
    title: "Bahasa yang mesra. Jawapan yang beradab.",
    excerpt:
      "Pelanggan Malaysia menukar bahasa di tengah ayat. Chatbot anda sepatutnya mengikut, bukan memaksa.",
    body: [
      {
        p: [
          "Perbualan sebenar di Malaysia jarang kekal dalam satu bahasa. Seseorang boleh memulakan dengan salam, bertanya dalam Bahasa Melayu, kemudian menyebut nama produk dalam bahasa Inggeris, semuanya dalam satu mesej.",
        ],
      },
      {
        h2: "Terjemahan bukan jawapan yang sama",
        p: [
          "Banyak chatbot ditulis dalam bahasa Inggeris kemudian diterjemah. Hasilnya betul dari segi tatabahasa tetapi bunyinya bukan seperti orang tempatan bercakap.",
          "Perbezaannya halus tetapi pelanggan perasan. Ia kedengaran seperti borang, bukan seperti seseorang yang bekerja di kedai anda.",
        ],
      },
      {
        h2: "Ikut bahasa pelanggan, bukan sebaliknya",
        p: [
          "Kalau pelanggan menulis dalam Bahasa Melayu, jawab dalam Bahasa Melayu. Kalau mereka bertukar, bertukar bersama mereka. Jangan paksa mereka memilih bahasa sebelum boleh bertanya.",
        ],
      },
      {
        h2: "Adab bukan tetapan, ia asas",
        p: [
          "Beradab bermaksud lebih daripada sekadar sopan. Ia bermaksud tidak memotong, tidak mendesak, dan tidak berpura-pura tahu.",
          "Bila pelanggan marah, nada yang tenang dan tidak defensif lebih membantu daripada ayat pemasaran. Bila pelanggan keliru, jawapan yang ringkas lebih membantu daripada jawapan yang panjang.",
        ],
      },
      {
        h2: "Ujian yang mudah",
        p: [
          "Baca jawapan chatbot anda dengan kuat. Kalau anda tidak selesa menyebutnya kepada pelanggan secara bersemuka, jangan biar ia dihantar bagi pihak anda.",
        ],
      },
    ],
  },
  {
    slug: "apa-yang-chatbot-perlu-tahu",
    category: "panduan",
    eyebrow: "Panduan",
    date: "2026-09-11",
    readMinutes: 4,
    art: "checklist",
    title: "Apa yang perlu chatbot anda tahu?",
    excerpt:
      "Senarai semak ringkas maklumat yang perlu disediakan sebelum melatih pembantu anda.",
    body: [
      {
        p: [
          "Chatbot hanya sebaik maklumat yang anda beri. Senarai ini merangkumi apa yang paling kerap ditanya oleh pelanggan, mengikut susunan kepentingan.",
        ],
      },
      {
        h2: "Produk dan perkhidmatan",
        list: [
          "Apa yang anda jual, dalam ayat yang pelanggan guna, bukan istilah dalaman",
          "Harga, dan sama ada ia termasuk cukai atau penghantaran",
          "Apa yang tiada dalam stok atau sudah dihentikan",
        ],
      },
      {
        h2: "Soalan lazim",
        list: [
          "Waktu operasi, termasuk hujung minggu dan cuti umum",
          "Kawasan penghantaran dan anggaran tempoh",
          "Cara pembayaran yang diterima",
          "Dasar pemulangan dan pertukaran",
        ],
      },
      {
        h2: "Polisi syarikat",
        p: [
          "Tuliskan apa yang boleh dan tidak boleh dijanjikan oleh chatbot. Contohnya, bolehkah ia menawarkan diskaun, atau mengesahkan tempahan.",
          "Kalau anda tidak menyatakannya, ia akan cuba membantu dalam keadaan yang sepatutnya ia serahkan kepada anda.",
        ],
      },
      {
        h2: "Gaya jawapan",
        p: [
          "Nyatakan panggilan yang anda guna untuk pelanggan, sama ada awak atau anda, dan sejauh mana formal anda mahu bunyinya.",
          "Beri dua atau tiga contoh jawapan yang anda sendiri pernah tulis. Contoh sebenar lebih berkesan daripada arahan panjang.",
        ],
      },
      {
        h2: "Apa yang tidak perlu dimasukkan",
        p: [
          "Jangan masukkan maklumat peribadi pelanggan, kata laluan, atau apa-apa yang anda tidak mahu dibaca oleh orang lain. Latih chatbot dengan maklumat perniagaan, bukan rekod pelanggan.",
        ],
      },
    ],
  },
];

export const featuredPost = POSTS.find((p) => p.featured) || POSTS[0];
export const otherPosts = POSTS.filter((p) => p !== featuredPost);

export function postBySlug(slug) {
  return POSTS.find((p) => p.slug === slug) || null;
}

export function categoryLabel(id) {
  const c = CATEGORIES.find((x) => x.id === id);
  return c ? c.label : id;
}

export function formatDate(iso) {
  const months = [
    "Januari", "Februari", "Mac", "April", "Mei", "Jun",
    "Julai", "Ogos", "September", "Oktober", "November", "Disember",
  ];
  const d = new Date(iso + "T00:00:00");
  if (isNaN(d)) return iso;
  return `${d.getDate()} ${months[d.getMonth()]} ${d.getFullYear()}`;
}
